<template>
  <div class="waterprooof pay">
    <div class="whiteMeasuerData">
      <div class="titleWrapper">
        <span class="title">{{firstTitle}}：</span><span class="values">{{totalAmount}}元</span>
      </div>
    </div>
    <div class="bgWrapper">
      <div class="bottom_border items">
        <span>项目</span>
        <span>面积</span>
        <span>金额</span>
      </div>
      <ul>
        <li v-for="(item,index) in projectList" class="items" :class="{bottom_border:index!=projectList.length-1}" :key="index">
          <span>{{item.name}}</span>
          <span>{{item.area}}</span>
          <span>{{item.amount}}</span>
        </li>
      </ul>
    </div>
    <div class="whiteMeasuerData">
      <div class="titleWrapper">
        <span class="title">支付方式：</span><span class="values">{{paymentType}}支付</span>
      </div>
    </div>
    <div class="bgWrapper">
      <div class="bottom_border items">
        <span>期数</span>
        <span>阶段</span>
        <span>比例</span>
        <span>金额</span>
        <span v-if="showTitle">佣金</span>
        <span v-if="showTitle">状态</span>
      </div>
      <ul>
        <li v-for="(item,index) in periodList" class="items" :class="{bottom_border:index!=periodList.length-1}" :key="index">
          <span>{{item.payName}}</span>
          <span>{{item.type}}</span>
          <span>{{item.payRate}}%</span>
          <span>{{item.paymentAmount}}元</span>
          <span v-if="showTitle">{{item.commissionAmount}}</span>
          <span  v-if="showTitle">{{item.paymentStatus}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "pay",
  data(){
    return {}
  },
  props:{
    showTitle:{
      type:Boolean,
      default:true
    },
    paymentType:{
      type:String,
      default:''
    },
    totalAmount:{
      type:String | Number,
      default:''
    },
    firstTitle:{
      type:String,
      default:'方案费用'
    },
    periodList:{
      type:Array,
      default:() => {
        return []
      }
    },
    projectList:{
      type:Array,
      default:() => {
        return []
      }
    },
  },
  methods:{

  }
}
</script>

<style scoped>

</style>
<style lang="less" scoped>
  .waterprooof{
    .titleWrapper{
      padding:12px 10px 12px 0;
      margin-left:10px;
      color:#000000;
      .title{
        font-size: 15px;
        font-weight: bolder;
        display: inline-block;
        min-width: 75px;
      }
      .values{
        font-size: 14px;
      }
    }
    .measureData{
      background: #F7F7F7;
      margin-bottom: 7px;
      border-radius: 3px;
    }
    .measureDataMargin{
      margin-bottom:0;
    }
    .whiteMeasuerData{
      // margin-bottom: 7px;
    }
    .measureData,.whiteMeasuerData,.lastMeasureData{
      color:#000000;
      // .titleWrapper{
      //   padding:12px 10px 12px 0;
      //   margin-left:10px;
      //   .title{
      //     font-size: 15px;
      //     font-weight: bolder;
      //     display: inline-block;
      //     min-width: 75px;
      //   }
      //   .values{
      //     font-size: 14px;
      //   }
      // }
      .titleWrapperMargin{
        margin-left:0;
      }
      .infoWrapper{
        padding:15px 15px 37px;
        p{
          color:#888888;
          font-size: 14px;
        }
      }
      .borderWrapper{
        border: 1px solid #EBEBEB;
        margin:0 9px;
        border-radius: 5px;
        div{
          display: flex;
          justify-content: space-around;
          margin: 16px 0;
          span{
            width: 25%;
            text-align: center;
            font-size: 14px;
          }
          &:last-child{
            span{
              color:#888888;
            }
          }
        }
      }
      
    }
    .bgWrapper{
      background: #F7F7F7;
      .items{
        padding:15px 0;
        display: flex;
        justify-content: space-around;
        span{
          flex: 1;
          text-align: center;
        }
      }
    }
  }
  .pay{
    padding-bottom:15px;
  }
  
</style>




// WEBPACK FOOTER //
// src/components/pay.vue